<div class="tabContainer">
  <mat-tab-group
    (selectedIndexChange)="activate($event)"
    [(selectedIndex)]="activeIndex"
    [disablePagination]="false"
  >
    <mat-tab class="emptyTab"></mat-tab>
    <mat-tab *ngFor="let view of views; let i = index; trackBy: trackView" class="not-see-through">
      <ng-template mat-tab-label>
        <span>
          {{ view.name }}
        </span>

        <sn-icon-button class="menu-button" matTooltip="Options" [matMenuTriggerFor]="tabMenu">
          <sn-icon>more_vert</sn-icon>
        </sn-icon-button>
      </ng-template>
      <mat-menu #tabMenu="matMenu">
        <ng-template matMenuContent>
          <button mat-menu-item (click)="addCameras(view)">
            <sn-icon fontSet="fal" fontIcon="fa-video"></sn-icon> Manage View Cameras
          </button>
          <button *ngIf="canArchiveTab(view, i)" mat-menu-item (click)="archiveTabView(view)">
            <sn-icon fontSet="fal" fontIcon="fa-box-archive"></sn-icon> Archive Tab
          </button>
          <button
            *ngIf="!view.archived && view?.user?.id === this.currentUserId"
            mat-menu-item
            (click)="$event.stopPropagation(); deleteView(view)"
          >
            <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon> Delete
          </button>
        </ng-template>
      </mat-menu>
    </mat-tab>
  </mat-tab-group>
</div>
